import { useCallback, useEffect } from "react";
import { useSearchParams } from "react-router-dom";

const utmParamsKey = "utmParams";

export const useUtmParams = () => {
  const [searchParams] = useSearchParams();

  const setUtmParams = useCallback((params) => {
    localStorage.setItem(utmParamsKey, JSON.stringify(params));
  }, []);

  const getUtmParams = useCallback(() => {
    const stored = localStorage.getItem(utmParamsKey);
    if (stored) {
      return JSON.parse(stored);
    }
    return null;
  }, []);

  const init = useCallback(() => {
    const utmSource = searchParams.get("utm_source");
    const utmMedium = searchParams.get("utm_medium");
    const utmCampaign = searchParams.get("utm_campaign");
    const utmContent = searchParams.get("utm_content");
    const utmTerm = searchParams.get("utm_term");
    const nextUtmParams = {};

    if (utmSource) {
      nextUtmParams.utmSource = utmSource;
    }
    if (utmMedium) {
      nextUtmParams.utmMedium = utmMedium;
    }
    if (utmCampaign) {
      nextUtmParams.utmCampaign = utmCampaign;
    }
    if (utmContent) {
      nextUtmParams.utmContent = utmContent;
    }
    if (utmTerm) {
      nextUtmParams.utmTerm = utmTerm;
    }

    if (utmSource || utmMedium || utmCampaign || utmContent || utmTerm) {
      setUtmParams(nextUtmParams);
    }
  }, [searchParams, setUtmParams]);

  useEffect(() => {
    init();
  }, [init]);

  return {
    getUtmParams,
  };
};
